import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import './wordExport.css';

const MONEY_PARTICLES = [
  { type: 'coin', x: -112, y: 82, rotation: -420, delay: 0, scale: 0.9 },
  { type: 'coin', x: -72, y: 138, rotation: 310, delay: 45, scale: 0.72 },
  { type: 'note', x: -28, y: 108, rotation: -32, delay: 90, scale: 0.82 },
  { type: 'coin', x: 18, y: 156, rotation: 390, delay: 20, scale: 0.8 },
  { type: 'note', x: 68, y: 126, rotation: 28, delay: 70, scale: 0.9 },
  { type: 'coin', x: 112, y: 76, rotation: -360, delay: 115, scale: 0.76 },
  { type: 'coin', x: -128, y: 34, rotation: 330, delay: 135, scale: 0.68 },
  { type: 'note', x: 126, y: 42, rotation: 38, delay: 150, scale: 0.76 },
  { type: 'coin', x: -82, y: 172, rotation: -300, delay: 180, scale: 0.64 },
  { type: 'coin', x: 86, y: 166, rotation: 420, delay: 165, scale: 0.7 },
];

const MoneyBurst = ({ burst }) => createPortal(
  <span
    className="word-export-money-burst"
    data-testid="word-export-money-burst"
    aria-hidden="true"
    style={{
      '--money-origin-x': `${burst.x}px`,
      '--money-origin-y': `${burst.y}px`,
    }}
  >
    {MONEY_PARTICLES.map((particle, index) => (
      <span
        key={`${burst.id}-${index}`}
        className={`word-export-money-particle word-export-money-particle--${particle.type}`}
        style={{
          '--money-x': `${particle.x}px`,
          '--money-y': `${particle.y * burst.verticalDirection}px`,
          '--money-rotation': `${particle.rotation}deg`,
          '--money-delay': `${particle.delay}ms`,
          '--money-scale': particle.scale,
        }}
      >
        ₽
      </span>
    ))}
  </span>,
  document.body
);

const WordExportButton = ({ children, onClick, ...buttonProps }) => {
  const [burst, setBurst] = useState(null);
  const burstSequenceRef = useRef(0);
  const cleanupTimerRef = useRef();

  useEffect(() => () => {
    window.clearTimeout(cleanupTimerRef.current);
  }, []);

  const handleClick = (event) => {
    const buttonBounds = event.currentTarget.getBoundingClientRect();
    const burstId = burstSequenceRef.current + 1;
    const originY = buttonBounds.top + buttonBounds.height / 2;
    burstSequenceRef.current = burstId;

    setBurst({
      id: burstId,
      x: buttonBounds.left + buttonBounds.width / 2,
      y: originY,
      verticalDirection: originY <= window.innerHeight * 0.65 ? 1 : -1,
    });

    window.clearTimeout(cleanupTimerRef.current);
    cleanupTimerRef.current = window.setTimeout(() => {
      setBurst(currentBurst =>
        currentBurst?.id === burstId ? null : currentBurst
      );
    }, 1200);

    onClick?.(event);
  };

  return (
    <>
      <button {...buttonProps} onClick={handleClick}>
        {children}
      </button>
      {burst && <MoneyBurst burst={burst} />}
    </>
  );
};

export default WordExportButton;
